import OrderDataItem from './OrderDataItem';

export default OrderDataItem;
